import { render } from "./ProfileTeacherTimetable.vue?vue&type=template&id=31f1b314&scoped=true"
import script from "./ProfileTeacherTimetable.vue?vue&type=script&lang=js"
export * from "./ProfileTeacherTimetable.vue?vue&type=script&lang=js"

import "./ProfileTeacherTimetable.vue?vue&type=style&index=0&id=31f1b314&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f1b314"]])

export default __exports__